module.exports = __webpack_public_path__ + "img/脸型精修--大图gif.d81750e8.gif";